import { render } from "./Failure.vue?vue&type=template&id=fb2682fe"
import script from "./Failure.vue?vue&type=script&lang=js"
export * from "./Failure.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rentapplication-frontend-vue/rentapplication-frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__